let controller = function(
		$scope,
		$filter,
		$ionicLoading,
		Session,
		Leaderboard
	) {
	"ngInject"

	var vm = this;

	vm.ranks = [];
	vm.scopes = [
		{ id: 1, value: 'today', display: $filter('ucfirst')($filter('translate')('today')) },
		{ id: 2, value: 'yesterday', display: $filter('ucfirst')($filter('translate')('yesterday')) },
		{ id: 3, value: 'thisweek', display: $filter('ucfirst')($filter('translate')('thisweek')) },
		{ id: 4, value: 'previousweek', display: $filter('ucfirst')($filter('translate')('previousweek')) },
		{ id: 5, value: 'thismonth', display: $filter('ucfirst')($filter('translate')('thismonth')) },
		{ id: 6, value: 'previousmonth', display: $filter('ucfirst')($filter('translate')('previousmonth')) }
	];
	if (Session.get('leaderboardScope')) {
		vm.scope = Session.get('leaderboardScope');
	} else {
		vm.scope = vm.scopes[0];
	}
	vm.metrics = [
		{ id: 1, value: 'revenue', display: $filter('ucfirst')($filter('translate')('revenue')) },
	];
	if (Session.get('leaderboardMetric')) {
		vm.metric = Session.get('leaderboardMetric');
	} else {
		vm.metric = vm.metrics[0];
	}

	vm.load = function() {
		$ionicLoading.show();
		Leaderboard.get(vm.metric.value, vm.scope.value).then(res => {
			vm.ranks = res;
		}).finally(() => {
			$ionicLoading.hide();
		})
	}

	vm.scopeChanged = function() {
		Session.set('leaderboardScope', vm.scope);
		vm.load();
	}

	vm.metricChanged = function() {
		Session.set('leaderboardMetric', vm.metric);
		vm.load();
	}

	$scope.$on('$ionicView.enter', function(e) {
		vm.load();
	});

}

export default controller;



// WEBPACK FOOTER //
// ./app/components/leaderboard/leaderboard.controller.js